
import React from 'react';
import Layout from '@/components/Layout';
import WhatsappMonitoringBoard from '@/components/WhatsappMonitoringBoard';

const Monitoring = () => {
  return (
    <Layout>
      <WhatsappMonitoringBoard />
    </Layout>
  );
};

export default Monitoring;
